import http from 'http'
import filter from 'src/utils/filter'
import server from 'src/utils/server'

export const getPlansByUsername = (username) => {
  return http.get(server.url_to('sellers/plans?' + filter.toQuery({ username: username })))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getSellerByUsername = (username) => {
  return http.get(server.url_to('sellers/info?' + filter.toQuery({ username: username })))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const validateEmail = (email) => {
  return http.post(server.url_to('customers/check_email?' + filter.toQuery({ email: email })))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const validateCpf = (cpf) => {
  return http.post(server.url_to('customers/check_cpf?' + filter.toQuery({ cpf: cpf })))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}



// WEBPACK FOOTER //
// ./src/app/pages/subscribe/services.js